import { getEnv, normalizeBaseUrl } from "@istari-frontend/shared";

const DEFAULT_REGISTRY_URL = "http://localhost:8000";

/**
 * Which registry the app addresses, and how. Exactly one of two modes, so the
 * discriminator keeps a caller from pairing a gateway base with a direct URL.
 */
export type RegistryTarget = { kind: "gateway"; digitalApiUrl: string } | { kind: "direct"; registryUrl: string };

/** Normalized VITE_ISTARI_DIGITAL_API_URL, or undefined when it is not usably set. */
export function gatewayBaseUrl(): string | undefined {
  return normalizeBaseUrl(getEnv("VITE_ISTARI_DIGITAL_API_URL"));
}

/** Normalized VITE_ISTARI_DIGITAL_REGISTRY_SERVICE_URL, else the older VITE_FILE_AUTH_ENDPOINT. Applies no default. */
export function directRegistryUrl(): string | undefined {
  return (
    normalizeBaseUrl(getEnv("VITE_ISTARI_DIGITAL_REGISTRY_SERVICE_URL")) ??
    normalizeBaseUrl(getEnv("VITE_FILE_AUTH_ENDPOINT"))
  );
}

/**
 * The registry the app should talk to. The gateway wins when configured, independent of the
 * identity flag; otherwise the app addresses the registry directly and falls back to localhost.
 */
export function resolveRegistryTarget(): RegistryTarget {
  const digitalApiUrl = gatewayBaseUrl();
  if (digitalApiUrl) return { kind: "gateway", digitalApiUrl };
  return { kind: "direct", registryUrl: directRegistryUrl() ?? DEFAULT_REGISTRY_URL };
}
